export const FETCH_PAYROLLS = 'FETCH_PAYROLLS';
export const FETCH_PAYROLL_COUNT = 'FETCH_PAYROLL_COUNT';
export const FETCH_GENERATE_PAYROLL_INFO = 'FETCH_GENERATE_PAYROLL_INFO';
export const FETCH_IHSS_ROOFS = 'FETCH_IHSS_ROOFS';
export const FETCH_ISR_ROOFS = 'FETCH_ISR_ROOFS';
export const FETCH_DEDUCTIONS = 'FETCH_DEDUCTIONS';
export const FETCH_PAYROLL_INFO = 'FETCH_PAYROLL_INFO';
export const FETCH_MEDICAL_DEDUCTIONS = 'FETCH_MEDICAL_DEDUCTIONS';
